import type { WithTestId } from '@/common';
import type { ISearchableDropdownOption } from '@/components/atoms';
import type { TOneOfItem } from '@/components/organisms/DynamicForm/types/one-of';
import type { FieldProps } from '@rjsf/utils';
import { useCallback, useMemo } from 'react';

import { SearchableDropdown } from '@/components/atoms';

export const SelectField = ({
  id,
  onChange,
  schema,
  formData,
  uiSchema,
  disabled,
  testId,
  onBlur,
}: WithTestId<FieldProps<string>>) => {
  const options = useMemo((): ISearchableDropdownOption[] => {
    if (Array.isArray(schema.enum)) {
      return schema.enum.map((value, index) => ({
        label: uiSchema?.['ui:enumNames']?.[index]! ?? value,
        value: value as string,
      }));
    }

    if (!Array.isArray(schema.oneOf)) {
      return [];
    }

    return (schema.oneOf as TOneOfItem[]).map(item => {
      return {
        label: item.title,
        value: item.const,
      };
    }) as ISearchableDropdownOption[];
  }, [schema.enum, schema.oneOf, uiSchema]);

  const handleBlur = useCallback(() => {
    // @ts-ignore
    onBlur && onBlur(id, formData);
  }, [id, onBlur, formData]);

  return (
    <SearchableDropdown
      placeholder={uiSchema?.['ui:placeholder']}
      // @ts-ignore
      name={id}
      options={options}
      value={formData}
      disabled={disabled}
      testId={testId}
      disablePortal
      textInputClassName="placeholder:text-gray-400"
      onChange={onChange}
      onBlur={handleBlur}
    />
  );
};
